import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "bell_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13 3.07V1h-2v2.07A7.002 7.002 0 0 0 5 10v6H3v2h18v-2h-2v-6a7.002 7.002 0 0 0-6-6.93ZM15 20a3 3 0 1 1-6 0h6Z"
    }, null, -1)
  ]))]))
}
export default { render: render }